import { decodeSearchResults, SearchResults } from '../../lib/dto';

export default function fetchResults(
  ...args: Parameters<typeof fetch>
): Promise<SearchResults> {
  return fetch(...args)
    .then(res => res.json())
    .then(decodeSearchResults);
}
